import getBasePath from '../../../../common/functions/api-resource';
import genericActions from './generic-resource';

const basePath = getBasePath('api', 'estrutura-usuario');

// Actions são ações que o resource terá.
// No exemplo abaixo, criamos uma ação 'list', que é um GET
// na url que aponta para a raíz da API
const estruturaUsuarioActions = {
  ...genericActions(basePath),
  listar: { method: 'GET', url: `${basePath}` },
  obter: { method: 'GET', url: `${basePath}/{id}` },
  listarEstruturasPai: { method: 'GET', url: `${basePath}?nome={nome}&idEdicao={idEdicao}` },
  inserirUsuarioRel: { method: 'POST', url: `${basePath}/inserirUsuarioRel` },
  atualizaUsuarioRel: { method: 'PUT', url: `${basePath}/atualizarUsuarioRel` },
  listarAutocomplete: { method: 'GET', url: `${basePath}?nome={nome}&indAtivo=true&{&idsEstruturaUsuarioNotIn*}` },
};

// Exportamos então o recurso, que não passa de uma função que recebe um
// Vue.$resource como parâmetro e retorna um resource customizado.
// Vue.$resource tem a seguinte assinatura:
// function Resource(url, params, actions, options)

export default resource => resource(`${basePath}`, {}, estruturaUsuarioActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/estrutura-usuario.js